import { Typography } from '@mui/material';
import React from 'react';
import EllipsisText from '../../common/components/EllipsisText';
import { H, V } from '../../common/Layout';
import { useStyling } from '../../common/Theme';
import { Field, NumberField } from '../attributes';
import TypePreview from '../TypePreview';

type NumberAttributePreviewProps = {
    field: Field;
    onClick?: (Field) => void;
};

export default (props: NumberAttributePreviewProps) => {
    const { field, onClick } = props;
    const { theme } = useStyling();
    const num = field as NumberField;

    return (
        <V onClick={onClick}>
            <TypePreview type={field.fieldType} />
            <EllipsisText text={num.label} sx={{ width: '140px' }} />
            <EllipsisText
                text={num.description}
                clampLines={2}
                sx={{ fontSize: 'smaller', color: theme.palette.text.disabled }}
            />
            <H sx={{ gap: 1 }}>
                <Typography>Min: {num.min}</Typography>
                <Typography>Max: {num.max}</Typography>
            </H>
        </V>
    );
};
